import React, { FunctionComponent } from 'react';
import { HoursReport } from '../../../types/apiDomain';
import styles from '../MyActivitiesPage.module.css';
import Text from 'antd/lib/typography/Text';
import { Tooltip } from 'antd';

const ApproximateHours: FunctionComponent<{ hoursReport?: HoursReport }> = ({ hoursReport }) => {
    if (!hoursReport?.approximateHoursForPeriod) {
        return <>Н/Д</>;
    }

    const difference = hoursReport.totalHoursForPeriod - hoursReport.approximateHoursForPeriod;
    const differenceString = `${difference > 0 ? '+' : ''}${difference}`;

    const tooltip =
        difference === 0
            ? 'Все списано'
            : difference < 0
            ? `Осталось списать ${-difference} ч`
            : `Списано больше на ${difference} ч`;

    return (
        <div className={styles.approximateHoursContainer}>
            <Text>{hoursReport.approximateHoursForPeriod}</Text>
            <Tooltip title={tooltip} placement="bottom">
                <Text type="secondary">({differenceString})</Text>
            </Tooltip>
        </div>
    );
};

export default ApproximateHours;
